<script setup lang="ts">
import { ref } from "vue";
import MenuList from "./MenuList.vue";
import { useGlobalData } from "@/utils/useGlobal";
import GiftCodeButton from "../../coms/GiftCodeButton.vue";

const { isPc, config } = useGlobalData();

const isShowMenu = ref(false);

function showMenu() {
  isShowMenu.value = !isShowMenu.value;
}
</script>
<template>
  <div class="top-wrap" :class="{ 'top-wrap-pc': isPc }">
    <div class="top-logo">
      <router-link to="/">
        <img class="logo" :src="config?.iconM" />
      </router-link>
      <div class="infor">
        <p class="txt1">{{ config?.gameDesc }}</p>
        <p class="txt2">{{ config?.gameDescLine2 }}</p>
      </div>
    </div>
    <div class="top-right">
      <GiftCodeButton v-if="!isPc" />
      <div class="menu" :class="{ close: isShowMenu }" @click="showMenu">
        <span v-for="item in 3" :key="item" class="line"></span>
      </div>
    </div>
  </div>
  <div
    v-show="isShowMenu"
    class="menu-wap"
    :class="{ animate: isShowMenu, 'menu-wap-pc': isPc }"
  >
    <MenuList @callback="showMenu" />
  </div>
</template>
<style lang="less" scoped>
.top-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 0.84rem;
  padding: 0 0.24rem;
  color: #ccc;
  background: #09090a url("~/images/m/top-bar/nav-bg.jpg") no-repeat center top /
    cover;

  .top-logo {
    display: flex;
    align-items: center;
    opacity: 0;
    animation: fadeLeft 0.6s 0.1s forwards;
  }

  .logo {
    width: 0.76rem;
    height: 0.76rem;
  }

  .infor {
    margin-left: 0.08rem;
    font-family: "HYJiangNanKaiSongW", sans-serif;
    font-size: 0.32rem;
    color: #dbc071;
    white-space: pre-line;

    .txt2 {
      margin-top: 0.05rem;
      font-size: 0.19rem;
      color: #cfb493;
    }
  }

  .top-right {
    display: flex;
    align-items: center;
    height: 100%;
    opacity: 0;
    animation: fadeRight 0.6s 0.1s forwards;
  }

  .menu {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 0.4rem;
    padding-top: 0.1rem;
    margin-left: 0.18rem;
    cursor: pointer;

    &.close {
      width: 0.38rem;
      height: 0.38rem;
      background: url("~/images/menu/close.png") no-repeat left top / cover;

      .line {
        display: none;
      }
    }
  }

  .line {
    display: block;
    width: 100%;
    height: 0.04rem;
    margin-bottom: 0.12rem;
    background-color: #e8e7e5;
    border-radius: 0.02rem;
    transition: all 0.3s;

    &:nth-child(2) {
      background-color: #d5aa68;
    }
  }

  .topbar-subscribe-button {
    position: static;
    height: auto;
    margin: 0;
    opacity: 1;
  }

  .subscribe {
    width: 1.67rem;
    height: 0.46rem;
    text-indent: -9999rem;
    background: url("~/images/m/top-bar/subscribe-btn.png") no-repeat 0 0 /
      cover;
    transition: all 0.2s;
  }
}

.menu-wap {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: #1c1817;
  transform: translate3d(100%, 0, 0);

  &.animate {
    animation: slideInRight 0.3s forwards;
  }
}

.top-wrap-pc {
  position: absolute;
  top: 0.2rem;
  right: 0.4rem;
  left: auto;
  width: 0.4rem;
  height: auto;
  padding: 0;
  background: none;

  .top-logo {
    display: none;
  }

  .menu {
    margin-left: 0;
  }
}

.menu-wap-pc {
  width: 5rem;
  background-color: #060403;
}
</style>
